import BackButton, { DEFAULT_SELECTOR } from 'CoreComponents/backButton';

document.querySelectorAll(DEFAULT_SELECTOR).forEach(backButton => {
  new BackButton(backButton);
});



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/backButton.js